export const environment = {
  production: false,
  git: '481e1bd2',
  env: 'dev',
  base: '//dev-api.mecon.3rdmill.tech/api/v1',
  gaTrackingId: 'ENV.gaTrackingId'
};
